import { useCallback, useState } from 'react';
const TRIGGER_TEXT = '{{';
const CLOSED = {
    anchorEl: null,
    at: null
};
export function useTokenTrigger(param) {
    let { inputRef, insertToken, setValueWithCaret } = param;
    const [{ anchorEl, at }, setState] = useState(CLOSED);
    const restoreBraces = useCallback((position)=>{
        const input = inputRef.current;
        if (!input) return;
        setValueWithCaret({
            value: input.value.slice(0, position) + TRIGGER_TEXT + input.value.slice(position),
            caret: position + TRIGGER_TEXT.length
        });
    }, [
        inputRef,
        setValueWithCaret
    ]);
    const dismiss = useCallback(()=>{
        setState(CLOSED);
        if (at != null) restoreBraces(at);
    }, [
        at,
        restoreBraces
    ]);
    const openAt = useCallback((request)=>{
        if (at != null) restoreBraces(at);
        setState({
            anchorEl: request.anchorEl,
            at: request.at
        });
    }, [
        at,
        restoreBraces
    ]);
    const openFrom = useCallback((element)=>{
        if (at != null) restoreBraces(at);
        setState({
            anchorEl: element,
            at: null
        });
    }, [
        at,
        restoreBraces
    ]);
    const select = useCallback((label)=>{
        var _inputRef_current;
        setState(CLOSED);
        if (at != null) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.setSelectionRange(at, at);
        insertToken(label);
    }, [
        at,
        inputRef,
        insertToken
    ]);
    const handleEscape = useCallback((event)=>{
        if (event.key !== 'Escape' || anchorEl == null) return false;
        event.preventDefault();
        event.stopPropagation();
        dismiss();
        return true;
    }, [
        anchorEl,
        dismiss
    ]);
    return {
        anchorEl,
        isOpen: anchorEl != null,
        openAt,
        openFrom,
        select,
        dismiss,
        handleEscape
    };
}
